import React, { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./components/ui/popover";
import { Calendar } from "./components/ui/calendar";
import { CalendarDays } from "lucide-react";
import { id as localeID } from "date-fns/locale";
import { format as formatDate, parseISO } from "date-fns";

// Convert Date object to YYYY-MM-DD (Jakarta timezone-agnostic string)
function toISODate(d) {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function parseISODate(s) {
  if (!s) return undefined;
  try {
    const [y, m, d] = s.split("-").map(Number);
    if (!y || !m || !d) return undefined;
    return new Date(y, m - 1, d);
  } catch { return undefined; }
}

export default function DatePickerID({ value, onChange, placeholder, testId, disabled, minDateISO }) {
  const [open, setOpen] = useState(false);
  const selected = parseISODate(value);
  const label = selected ? formatDate(selected, "EEEE, d MMMM yyyy", { locale: localeID }) : (placeholder || "Pilih tanggal");
  const minDate = minDateISO ? parseISODate(minDateISO) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          disabled={disabled}
          className={`date-picker-btn ${!selected ? "muted-text" : ""}`}
          aria-label={label}
        >
          <CalendarDays size={16}/>
          <span>{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="date-picker-pop" data-testid={`${testId}-pop`}>
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => { onChange(toISODate(d)); setOpen(false); }}
          locale={localeID}
          disabled={minDate ? { before: minDate } : undefined}
          initialFocus
          showOutsideDays
        />
      </PopoverContent>
    </Popover>
  );
}
